import { render, staticRenderFns } from "./CustomFieldTable.vue?vue&type=template&id=ac18815c&scoped=true"
import script from "./CustomFieldTable.vue?vue&type=script&lang=ts"
export * from "./CustomFieldTable.vue?vue&type=script&lang=ts"
import style0 from "./CustomFieldTable.vue?vue&type=style&index=0&id=ac18815c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac18815c",
  null
  
)

export default component.exports